import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.constructor";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import SmsPushConfigDrawer from './modules/SmsPushConfigDrawer'
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
import { httpAction } from '@/api/manage'; // 站点树展示

import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: "SmsPushConfigList",
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {// SmsPushConfigDrawer
  },
  data: function data() {
    return {
      pagePath: '/sys/sms/push/config',
      pageTitle: '短信推送配置',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userName',
        colName: 'user_name',
        title: '推送人员',
        align: "center",
        sorter: false,
        scopedSlots: {
          customRender: 'userName'
        }
      }, {
        dataIndex: 'phone',
        colName: 'phone',
        title: '电话',
        align: "center",
        width: 400,
        sorter: false,
        scopedSlots: {
          customRender: 'phone'
        }
      }, {
        dataIndex: 'status',
        colName: 'status',
        title: '是否推送',
        align: "center",
        sorter: false,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        dataIndex: 'sort',
        colName: 'sort',
        title: '排序',
        align: "center",
        sorter: true,
        scopedSlots: {
          customRender: 'sort'
        }
      }, {
        dataIndex: 'remark',
        colName: 'remark',
        title: '备注',
        align: "center",
        sorter: false,
        scopedSlots: {
          customRender: 'remark'
        }
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      siteId: '',
      addIndex: 0,
      errorText: ''
    };
  },
  created: function created() {},
  //站点树监视
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    handleAdd1: function handleAdd1() {
      var newData = _toConsumableArray(this.dataSource); // this.addParamDataIndex++


      newData.push({
        key: 'A1_' + this.addIndex,
        userName: '',
        phone: '',
        status: '',
        sort: '',
        remark: '',
        editable: true
      });
      this.addIndex = this.addIndex + 1;
      this.dataSource = newData;
      console.log(this.dataSource);
    },
    phoneBlur: function phoneBlur(e, record) {
      console.log(e, record);
      var value = e.target._value;

      if (value) {
        if (new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/).test(value)) {
          record['showPhone'] = false;
          this.$forceUpdate();
        } else {
          record['showPhone'] = true;
          this.errorText = '电话号码格式错误!';
          this.$forceUpdate();
        }
      } else {
        record['showPhone'] = true;
        this.errorText = '电话号码不能为空!';
        this.$forceUpdate();
      }
    },
    addList: function addList(record) {
      var _this = this;

      if (!record.showPhone) {
        var formData = {
          userName: record.userName,
          phone: record.phone,
          status: record.status,
          sort: record.sort,
          remark: record.remark,
          siteId: this.queryParam.siteId,
          id: record.id
        };
        var method = '';

        if (!record.id) {
          method = 'post';
        } else {
          method = 'put';
        }

        httpAction(this.pagePath, formData, method).then(function (res) {
          if (res.success) {
            _this.$notification.success({
              message: res.message
            });

            _this.$emit('ok');

            record.editable = false;
          } else {
            _this.$notification.warning({
              message: res.message
            });
          }
        }).finally(function () {
          _this.confirmLoading = false;
        });
      }
    },
    handleEdit1: function handleEdit1(record) {
      record.editable = true;
    },
    handleDelete1: function handleDelete1(id, key) {
      if (id) {
        this.handleDelete(id);
      } else {
        var dataSource = _toConsumableArray(this.dataSource);

        this.dataSource = dataSource.filter(function (item) {
          return item.key !== key;
        });
      }
    },
    userNameChange: function userNameChange(e, record) {
      console.log(e);
      record.userName = e.target._value;
    }
  }
};